(() => {
  if (!window.theme?.settings?.enableAnimations || matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.reveal').forEach((element) => element.classList.add('is-visible')); return;
  }
  const observer = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }), { threshold: .12, rootMargin: '0px 0px -40px' });
  const observe = (scope = document) => scope.querySelectorAll('.reveal:not(.is-visible)').forEach((element) => observer.observe(element));
  observe(); document.addEventListener('theme:section-rendered', (event) => observe(event.detail.section));
})();
